import { KEY } from "@/shared/constants/keyboard";

type Props = {
	addTab: () => void;
	disabled: boolean;
};
export const AddDashboardButton: React.FC<Props> = ({ addTab, disabled }) => {
	function handleInteraction() {
		if (!disabled) {
			addTab();
		}
	}

	return (
		<div
			data-testid="add-tab-button"
			onClick={handleInteraction}
			onKeyDown={(e) => {
				[KEY.ENTER, KEY.SPACE].includes(e.key) && handleInteraction();
			}}
			className="tab cursor-pointer font-bold disabled:opacity-50"
		>
			<span aria-hidden="true">+</span>
		</div>
	);
};
